__turbopack_context__.v({
  "streamingCaret": "AiMessage-module-scss-module__eZyRjG__streamingCaret",
  "welloAgentCaretBlink": "AiMessage-module-scss-module__eZyRjG__welloAgentCaretBlink",
});
